import { render } from "./ViewArchiveItem.vue?vue&type=template&id=e83e935e"
import script from "./ViewArchiveItem.vue?vue&type=script&lang=js"
export * from "./ViewArchiveItem.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__